<template>
	<div>
		<v-chart class="chart_zhaban" :options="line" @datazoom='onDataZoom($event,line)'/>
		<!-- <div>{{line}}</div> -->
	</div>

</template>

<script>
	import ECharts from 'vue-echarts'
	import Moment from 'moment'
	
	// import 'echarts/lib/component/polar'
	import {
		request_zzquant
	} from "../../network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	// const downColor = '#00da3c';
	const downBorderColor = '#008F28';
	let dataZoomData = {
		"start": 50,
		"end": 100
	}

	function splitData(rawData) {
		// console.log(rawData);
		var categoryData = [],
			max_lb_num = [],
			lb_3_num = [],
			uplimit_num = [],
			downlimit_num = [],
			max_lb_stocks = [],
			damian_num = [],
			second_lb_num = [],
			fb_num = [],
			mian_num = [],
			bigleg_num = [],
			uplimit_n_num = [],
			zb_num = [],
			zb_pct = [],
			zs = [];
		var uplimit_num_m = [],
			downlimit_num_m = [];
		for (var i = 0; i < rawData.length; i++) {
			categoryData.push(rawData[i]['date1']);
			max_lb_num.push(rawData[i]['max_lb_num']);
			second_lb_num.push(rawData[i]['second_lb_num']);
			lb_3_num.push(rawData[i]['lb_3_num']);
			max_lb_stocks.push(rawData[i]['max_lb_stocks']);
			damian_num.push(rawData[i]['damian_num']);
			fb_num.push(rawData[i]['fb_num']);
			mian_num.push(rawData[i]['mian_num']);
			bigleg_num.push(rawData[i]['bigleg_num']);
			zb_num.push(rawData[i]['zb_num']);
			zs.push(rawData[i]['zs']);

			uplimit_num.push(rawData[i]['uplimit_num']);
			uplimit_n_num.push(rawData[i]['uplimit_n_num']);
			downlimit_num.push(rawData[i]['downlimit_num']);
			var uplimit = rawData[i]['uplimit_num']
			uplimit = uplimit > 100 ? 100 : uplimit;
			uplimit_num_m.push(uplimit / 100);
			var downlimit = rawData[i]['downlimit_num'];
			downlimit = downlimit > 100 ? 100 : downlimit;
			downlimit_num_m.push(-downlimit / 100);

			zb_pct.push((rawData[i]['zb_num'] / (rawData[i]['zb_num'] + rawData[i]['uplimit_n_num']) * 100).toFixed(2))
		}
		return {
			categoryData: categoryData,
			max_lb_num: max_lb_num,
			second_lb_num: second_lb_num,
			lb_3_num: lb_3_num,
			uplimit_num: uplimit_num,
			downlimit_num: downlimit_num,
			downlimit_num_m: downlimit_num_m,
			uplimit_num_m: uplimit_num_m,
			max_lb_stocks: max_lb_stocks,
			damian_num: damian_num,
			fb_num: fb_num,
			mian_num: mian_num,
			bigleg_num: bigleg_num,
			uplimit_n_num: uplimit_n_num,
			zb_num: zb_num,
			zb_pct: zb_pct,
			zs: zs,
		};
	}

	export default {
		data() {
			let today =  Moment().add(-1,'years').format('YYYY-MM-DD'); 
			return {
				bar: {},
				date1:today,
				line: {
					title: {
						text: '炸板率',
						subtext: '炸板率',
						left: 0,
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					color: [upBorderColor, upColor, downBorderColor, "#cccccc"],
					legend: {
						data: ['自然涨停', '涨停板', '炸板率', '中证500'],
						textStyle: {
							color: '#999999'
						},
					},
					grid: [{
						left: '5%',
						right: '5%',
						// height: '75%'
					}],
					xAxis: [{
						type: 'category',
						scale: true,
						boundaryGap: false,
						axisLine: {
							onZero: false,
							lineStyle: { color: '#666666' }
						},
						splitLine: {
							show: false
						},
						splitNumber: 10,
						min: 'dataMin',
						max: 'dataMax',
						axisPointer: {
							z: 100
						},
						axisLabel: {
							fontSize: 11,
							color: '#999999'
						},
					}],
					yAxis: [{
						name: "涨停",
						scale: true,
						position: 'right',
						min: 0,
						max: 'dataMax',
						splitNumber: 10,
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							interval: 0,
							formatter: '{value}',
							color: '#999999'
						},
						axisLine: {
							lineStyle: { color: '#666666' }
						},
						nameTextStyle: {
							color: '#999999'
						},
						lineStyle: {
							normal: {
								width: 1,
								opacity: 0.6,
								color: upBorderColor
							}
						}
					}, {
						name: "炸板率",
						scale: true,
						position: 'left',
						offset: 1,
						min: 0,
						max: 100,
						splitNumber: 10,
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							interval: 0,
							formatter: '{value}%',
							color: '#999999'
						},
						axisLine: {
							lineStyle: { color: '#666666' }
						},
						nameTextStyle: {
							color: '#999999'
						},
						color: 'red',
					}, {
						name: "指数",
						scale: true,
						offset: 35,
						position: 'right',
						min: 'dataMin',
						max: 'dataMax',
						splitNumber: 10,
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						},
						axisLabel: {
							interval: 0,
							formatter: '{value}',
							color: '#999999'
						},
						axisLine: {
							lineStyle: { color: '#666666' }
						},
						nameTextStyle: {
							color: '#999999'
						},
					}, ],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: dataZoomData.start,
						// 	end: dataZoomData.end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0],
							y: '90%',
							start: dataZoomData.start,
							end: dataZoomData.end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: [],
					tooltip: {
						trigger: 'axis',
					}
				}
			}
		},
		components: {
			'v-chart': ECharts
		},
		computed: {

		},
		mounted() {
			this.refresh();
		},
		methods:{
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis.data[0])
						if(data_start < Moment(this.date1)){
							return
						}
						this.date1 = data_start.add(-1,'years').format("YYYY-MM-DD")
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh()
					}
				}
			},
			refresh(){
				request_zzquant({
						url: '/v3/sentiment/data',
						params: {
							"date1": this.date1,
							"with_zs": "399905"
						}
					})
					.then(res => {
						// console.log(res['data']);
						var splitDataItem = splitData(res['data']['data']);
						// console.log(splitDataItem);
						this.line['xAxis'] = {
							data: splitDataItem.categoryData,
						};
						let series_data = []
						series_data.push({
							name: '自然涨停',
							data: splitDataItem.uplimit_n_num,
							type: 'line',
							symbol: 'circle',
							showSymbol: false,
							// markLine: {
							//     data: [
							//         {type: 'average', name: '涨停均值', symbol: 'circle',}
							//     ]
							// },
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.9,
									color: upBorderColor
								}
							},
				
							yAxisIndex: 0
						});
						series_data.push({
							name: '涨停板',
							data: splitDataItem.uplimit_num,
							type: 'line',
							symbol: 'circle',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.5,
									color: upColor
								},
							},
							yAxisIndex: 0
						});
						series_data.push({
							name: '炸板率',
							data: splitDataItem.zb_pct,
							type: 'line',
							symbol: 'circle',
							showSymbol: false,
							markLine: {
								data: [{
									type: 'average',
									name: '炸板率均值',
									symbol: 'circle',
								}]
							},
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.9,
									color: downBorderColor
								}
							},
							yAxisIndex: 1
						});
				
						series_data.push({
							name: '中证500',
							data: splitDataItem.zs,
							type: 'line',
							symbol: 'circle',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.7
								}
							},
							yAxisIndex: 2
						});
				
						this.line['series'] = series_data;
					})
					.catch(err => {
						console.log(err);
					});
			},
		}
	}
</script>

<style scoped>
.chart_zhaban {
	width: 100%;
	height: 300px;
}
</style>
